import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { Coach } from '@addmile/backend-client';

interface CoachCabinetStore {
  coach: Coach;
}

export const useCoachCabinetStore = create<CoachCabinetStore>()(
  persist(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    immer((_set) => ({
      coach: {} as Coach,
    })),
    {
      name: 'coach-cabinet-storage',
    },
  ),
);
